<template>
  <md-button class="md-primary" @click="$emit('click')" v-bind="$props">
    <template v-if="!disabled">
      <slot></slot>
      <md-tooltip md-direction="bottom" v-if="toolTip">{{
        toolTip
      }}</md-tooltip>
    </template>
    <template v-else> Processing... </template>
  </md-button>
</template>
<script>
export default {
  props: {
    disabled: Boolean,
    toolTip: String,
    click: Function,
  },
};
</script>
